(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["card-images"]) return;
  try {
     
document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('.card-images img');
    if(images.length > 0) {
        const cardSlider = tns({
            container: '.card-images',
            items: 3,
            slideBy: 'page',
            autoplay: false,
            controls: false,
            nav: false,
            mouseDrag: false,
            touch: false,
            gutter: 35,
            responsive: {
                768: {
                    items: 1
                },
                1024: {
                    items: 3
                }
            }
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choose-products"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if(window.innerWidth <= 768) {
    const sliderPost = tns({
      container: '.product-grids',
      items: 1,
      slideBy: 'page',
      autoplay: false,
      controls: false,
      loop: false,
      nav: false,
      mouseDrag: true,
      gutter: 16
    }) 
    
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.accordion-item');

    accordionItems.forEach((item) => {
      const button = item.querySelector('button');
      const panel = item.querySelector('[role="region"]');

      button.addEventListener('click', function () {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          button.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        } else {
          button.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-items"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
      const sliderPost = tns({
        container: '.ngrid-items',
        items: 1,
        slideBy: 'page',
        autoplay: false,
        controls: false,
        loop: false,
        nav: false,
        mouseDrag: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-with-numbers"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('[aria-expanded]');
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
        const targetId = this.getAttribute('aria-controls');
        const target = document.getElementById(targetId);
        const icon = this.querySelector('svg');
        if (icon) {
          icon.classList.toggle('rotate-180');
        }
        if (target) {
          target.style.display = expanded ? 'none' : '';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-hero"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
      const buttons = document.querySelectorAll('.colors-buttons button'),
      slidesContainer = document.querySelector('.colors-slides .flex');

      let closeModalButtons = document.querySelectorAll('.close-modal'),
      modalVideo = document.querySelectorAll('.modal-videos'),
      videoEmbed = document.querySelector('.video_embed');

      if(modalVideo.length > 0) {
          videoEmbed.addEventListener('click', function() {
              modalVideo[0].style.display = 'flex';
          });
          
          closeModalButtons.forEach(function(button) {
              button.addEventListener('click', function() {
                console.log(modalVideo[0])
                  modalVideo[0].style.display = 'none';
              });
          });
      }

      buttons.forEach((button, index) => {
          button.addEventListener('click', (evt) => {
              slidesContainer.style.transform = `translateX(-${index * 100}%)`;
              buttons.forEach(btn => {
                  btn.classList.remove('w-12', 'h-12', 'border-[8px]', 'border-white', 'shadow-lg');
                  btn.classList.add('w-8', 'h-8', 'border-0');
              });
              evt.currentTarget.classList.remove('w-8', 'h-8', 'border-0');
              evt.currentTarget.classList.add('w-12', 'h-12', 'border-[8px]', 'border-white', 'shadow-lg');
          });
      });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let accordionItems = document.querySelectorAll('.accordion-item h3 button');
    if (accordionItems.length > 0) {
      accordionItems.forEach((item) => {
        item.addEventListener('click', (evt) => {
          let self = evt.currentTarget,
            index = self.getAttribute('index'),
            content = document.querySelector(`#weight-panel[index="${index}"]`);
          if (self.getAttribute('aria-expanded') == 'false') {
            self.setAttribute('aria-expanded', 'true');
            content.removeAttribute('hidden');
          } else {
            self.setAttribute('aria-expanded', 'false');
            content.setAttribute('hidden', true);
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slide"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const testimonialsData = document.getElementById('testimonials-data').textContent,
      testimonials = JSON.parse(testimonialsData);
    console.log(testimonials);
    let categories = testimonials.map((testimonial) => testimonial.categoria);
    let categoriesUnique = [...new Set(categories)];
    console.log(categoriesUnique);
    if (categoriesUnique.length > 0) {
      categoriesUnique.forEach((category, index) => {
        const button = document.createElement('button');

        button.classList.add('px-2', 'py-1', 'rounded-full', 'border', 'text-sm', 'transition', 'duration-200');
        if (index === 0) {
          button.classList.add('bg-[#F6C267]', 'text-[#001F4D]', 'border-[#F6C267]');
        } else {
          button.classList.add('text-white', 'border-white/30');
        }
        button.textContent = category;
        button.setAttribute('data-category', category.toLowerCase().replace(/\s/g, '-'));
        document.querySelector('.categories').appendChild(button);
      });

      let getTestimonialsByFirstCategory = testimonials.filter(
        (testimonial) =>
          testimonial.categoria.toLowerCase().replace(/\s/g, '-') ===
          categoriesUnique[0].toLowerCase().replace(/\s/g, '-')
      );
      if (getTestimonialsByFirstCategory.length > 0) {
        let html = '';
        getTestimonialsByFirstCategory.forEach((testimonial) => {
          html += `
          <div class="pb-4" data-category="${testimonial.categoria.toLowerCase().replace(/\s/g, '-')}">
            <div class="relative flex flex-col items-center h-full">
              <div class="h-64 w-full relative rounded-lg overflow-hidden">
                <img src="https://res.cloudinary.com/prettylitter/image/upload/w_auto,q_auto,f_auto,dpr_1/homepage_2025/testimonials/lottiepopstyle" class="w-full h-full object-cover">
              </div>
              <div class="flex no-gap flex-col w-[90%] min-h-[188px] flex-grow mx-auto -mt-4 p-5 z-10 rounded-lg text-cobalt-900 mblur">
                <div class="flex justify-between items-center mb-3">
                  <p class="text-base">${testimonial.titulo}</p>
                  <div class="flex no-gap">
                    <img src="https://res.cloudinary.com/prettylitter/image/upload/w_auto,q_auto,f_svg,dpr_1/homepage_2025/5stars.svg" class="h-4">
                  </div>
                </div>
                <p class="text-sm flex-grow">
                  ${testimonial.texto}
                </p>
              </div>
            </div>
          </div>
          `;
        });
        console.log(html);
        document.querySelector('.testimonials').innerHTML = html;

        let sliderTestimonials = tns({
          container: '.testimonials',
          items: 1,
          slideBy: 'page',
          autoplay: false,
          controls: false,
          loop: false,
          nav: false,
          navPosition: 'bottom',
          mouseDrag: true,
          gutter: 16,
          responsive: {
            768: {
              items: 1,
            },
            1024: {
              items: 3,
            },
          },
        });
      }

      let categoryButtons = document.querySelectorAll('.categories button');
      if (categoryButtons.length > 0) {
        categoryButtons.forEach((el) => {
          el.addEventListener('click', (evt) => {
            let category = evt.target.getAttribute('data-category');
            let getTestimonialsByCategory = testimonials.filter(
              (testimonial) => testimonial.categoria.toLowerCase().replace(/\s/g, '-') === category
            );
            console.log(getTestimonialsByCategory);

            // Update testimonials container with filtered testimonials
            let html = '';
            getTestimonialsByCategory.forEach((testimonial) => {
              html += `
              <div class="pb-4" data-category="${testimonial.categoria.toLowerCase().replace(/\s/g, '-')}">
                <div class="relative flex flex-col items-center h-full">
                  <div class="h-64 w-full relative rounded-lg overflow-hidden">
                    <img src="${testimonial.imagen}" class="w-full h-full object-cover">
                  </div>
                  <div class="flex no-gap flex-col w-[90%] min-h-[188px] flex-grow mx-auto -mt-4 p-5 z-10 rounded-lg text-cobalt-900 mblur">
                    <div class="flex justify-between items-center mb-3">
                      <p class="text-base">${testimonial.titulo}</p>
                      <div class="flex no-gap">
                        ${
                          testimonial.estrellas
                            ? `<img src="https://res.cloudinary.com/prettylitter/image/upload/w_auto,q_auto,f_svg,dpr_1/homepage_2025/5stars.svg" class="h-4">`
                            : ''
                        }
                      </div>
                    </div>
                    <p class="text-sm flex-grow">
                      ${testimonial.texto}
                    </p>
                  </div>
                </div>
              </div>
              `;
            });
            console.log(html);
            document.querySelector('.testimonials').innerHTML = html;

            // Reinitialize TinySlider for the new content
            if (typeof tns === 'function') {
              tns({
                container: '.testimonials',
                items: 1,
                slideBy: 'page',
                autoplay: false,
                controls: false,
                loop: false,
                nav: false,
                navPosition: 'bottom',
                mouseDrag: true,
                gutter: 16,
                responsive: {
                  768: {
                    items: 1,
                  },
                  1024: {
                    items: 3,
                  },
                },
              });
            }

            // change button active class
            document.querySelectorAll('.categories button').forEach((button) => {
              button.classList.remove('bg-[#F6C267]', 'text-[#001F4D]', 'border-[#F6C267]');
              button.classList.add('text-white', 'border-white/30');
            });
            event.target.classList.remove('text-white', 'border-white/30');
            event.target.classList.add('bg-[#F6C267]', 'text-[#001F4D]', 'border-[#F6C267]');
          });
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
